<template>

  <oxygen-menu-table
      :row-style="rowStyle"
      v-bind:tableData="tableData"
      hideCheckboxCol="true"
      hideFolderCol="true"
      ref="menuTable"
  ></oxygen-menu-table>
  <VueDatePicker ref="scheduleDate" style="flex-grow:1; font-size:12px;" v-model="scheduleDate" utc></VueDatePicker>
</template>

<script>
  import OxygenMenuTable from './../OxygenMenuTable/OxygenMenuTable.vue';
  import * as oxygenUtil from './../OxygenUtil/oxygenutil.js';
  import VueDatePicker  from '@vuepic/vue-datepicker';

  export default {
      components: { OxygenMenuTable, VueDatePicker },
      props: {

      },
      data: function () {
        return {
          scheduleDate: '',
          rowStyle: {
            'line-height': '0px'
          },
          tableData: {
            searchLib: {},
            showCheckbox: false,
            showFolder: false,
            showHeader: false,
            showRightMenu: false,
            cols: [
              {
                header: {
                  type: 'html',
                  html: ''
                },
                type: 'html',
                width: '120px',
                callback: () => {
                }
              },
              {
                header: {
                  type: 'html',
                  html: ''
                },
                type: 'html',
                colspan: 1,
                width: '120px',
                //width: '2em',
                callback: () => {
                }
              },
              {
                header: {
                  type: 'html',
                  html: ''
                },
                type: 'html',
                //width: '1.6em',
                width: '88px',
                colspan: 1,
                callback: () => {
                }
              },
              {
                header: {
                  type: 'html',
                  html: ''
                },
                type: 'html',
                width: '88px',
                colspan: 1,
                callback: () => {
                }
              }
              ],
            dataRows: []
          },
          dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
          time1Array: ['6AM', '7AM', '8AM', '9AM', '10AM', '11AM', '12noon'],
          time2Array: ['1PM', '2PM', '3PM', '4PM', '5PM', '6PM', '7PM'],
        }
      },

      mounted() {
        console.log('OxygenScheduler-mounted', 'called');
        let today = new Date(Date.now()), dayIndex = today.getDay();
        const options = {
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        };
        for(let i = 0; i < 7; i++) {
          this.addSchedulerRow(i, this.dayNames[dayIndex], today.toLocaleDateString(undefined, options), this.time1Array[i], this.time2Array[i]);
          dayIndex = (dayIndex + 1) % 7;
          today.setDate(today.getDate() + 1);
        }

      },
      computed: {},
      watch: {
        'scheduleDate': (newVal, oldVal) => {
          this.$emit('schedule-data-changed', newVal);
        }
      },
      methods: {
        timeButtonClicked(day, date, time) {
          let current = new Date(this.scheduleDate);
          let parsedHour = parseInt(time);
          if(time.includes('PM')) {
            parsedHour += 12;
          }

          current.setHours(parsedHour);
          this.scheduleDate = current;
        },
        dayButtonClicked(day, date) {
          let current = new Date(date);
          this.scheduleDate = current.toISOString();
        },
        addSchedulerRow(index, day, date, time1, time2) {
          this.$refs.menuTable.addRow({
            cols: [
              {
                html: `     <button
          type="button"
          style="height: 25px; flex-grow: 0;width: 100px"
          class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat"
      >
        <span class="dhx_button__text" :class="selectedModeButton.class || {}">${day}</span>
      </button>`,
                type: 'html',
                styleObj: {'display': 'flex'},
                callback: (dataRow) => {
                  this.dayButtonClicked(day, date);
                }
              },
              {
                html: `${date}`,
                type: 'html',
                //styleObj: {'display': 'flex'},
                callback: (dataRow) => {
                  this.dayButtonClicked(day, date);
                }
              },
              {
                html: `     <button
          type="button"
          style="height: 27px; flex-grow: 0; width: 80px"
          class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat"
      >
        <span class="dhx_button__text" :class="selectedModeButton.class || {}">${time1}</span>
      </button>`,
                type: 'html',
                styleObj: {'display': 'flex'},
                callback: (dataRow) => {
                  this.timeButtonClicked(day, date, time1);
                }
              },
              {
                html: `     <button
          type="button"
          style="height: 27px; flex-grow: 0; widith: 80px"
          class="dhx_button dhx_button--color_primary dhx_button--size_medium dhx_button--view_flat"
      >
        <span class="dhx_button__text" :class="selectedModeButton.class || {}">${time2}</span>
      </button>`,
                type: 'html',
                //styleObj: {'display': 'flex'},
                callback: (dataRow) => {
                  this.timeButtonClicked(day, date, time2);
                }
              }
            ],
            path: `${index}`
          });
        }
      }
    }
  </script>
<style>
@import '@vuepic/vue-datepicker/dist/main.css';

</style>